<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{ title }} Wear Part</h1>
    </div>
    <form class="ui form segment" @submit.prevent="wearUpdate">
      <div class="ui grid stackeable">
        <div class="row">
          <div class="eight wide column">
            <label>Companies</label>
            <div
              class="ui fluid search selection dropdown"
              id="companiesSelect"
            >
              <input
                type="hidden"
                name="companies"
                v-model="companyId"
                id="companies"
                @change="onCompanyChange"
              />
              <div class="default text">Companies</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="company in companyList"
                  :key="company.value"
                  v-bind:data-value="company.value"
                >
                  {{ company.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <label>Machine</label>
            <div class="ui fluid search selection dropdown" id="MachineSelect">
              <input
                type="hidden"
                name="Machine"
                v-model="machineId"
                required
                id="Machine"
                @change="onMachineChange"
              />
              <div class="default text">Select Machine</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <!-- <div class="item" data-value="">Select Machine</div> -->
                <div
                  class="item"
                  v-for="machine in machines"
                  :key="machine.id"
                  v-bind:data-value="machine.value"
                >
                  {{ machine.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="machineId">
          <div class="eight wide column">
            <label>Assembly</label>
            <div class="ui fluid search selection dropdown" id="AssemblySelect">
              <input
                type="hidden"
                name="Assembly"
                v-model="assemblyId"
                required
                id="Assembly"
                @change="onAssemblyChange"
              />
              <div class="default text">Select Assembly</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <!-- <div class="item" data-value="">Select Assembly</div> -->
                <div
                  class="item"
                  v-for="assembly in assemblies"
                  :key="assembly.id"
                  v-bind:data-value="assembly.value"
                >
                  {{ assembly.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="assemblyId">
          <div class="eight wide column">
            <label>Sub-Assembly</label>
            <div
              class="ui fluid search selection dropdown"
              id="SubAssemblySelect"
            >
              <input
                type="hidden"
                name="Subassembly"
                v-model="subAssemblyId"
                required
                id="Subassembly"
                @change="onSubAssemblyChange"
              />
              <div class="default text">Select Sub-Assembly</div>
              <i class="remove icon"></i>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="assembly in subAssemblies"
                  :key="assembly.id"
                  v-bind:data-value="assembly.value"
                >
                  {{ assembly.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="subAssemblyId">
          <div class="eight wide column">
            <label>Part</label>
            <div class="ui fluid search selection dropdown" id="PartIdSelect">
              <input
                type="hidden"
                name="part"
                v-model="partId"
                id="part"
                required
                @change="onPartsChange"
              />
              <div class="default text">Select Part</div>
              <i class="remove icon"></i>
              <i class="dropdown icon"></i>
              <div class="menu">
                <!-- <div class="item" data-value="">Select Part</div> -->
                <div
                  class="item"
                  v-for="part in parts"
                  :key="part.value"
                  v-bind:data-value="part.value"
                >
                  {{ part.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <label>Quantity per Machine</label>
            <input
              type="text"
              name="QtyPerMachine"
              v-model="quantityPerMachine"
            />
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <div class="ui toggle checkbox">
              <input
                id="pending"
                type="checkbox"
                tabindex="0"
                class
                v-model="pending"
              />
              <label>Active</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{ button }} Wear</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
          <div class="eight wide column">
            <div class="ui primary button right floated" @click="deleteModal">
              Delete Wear
            </div>
          </div>
        </div>
      </div>
    </form>
    <semantic-modal small flip :active.sync="showModal">
      <div class="ui header">
        Delete Wear Part<i class="close icon" @click="showModal = false"></i>
      </div>
      <div class="content">Are you sure you want to delete this assembly?</div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">Nope</div>
        <div class="ui positive right labeled icon button" @click="wearDelete">
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

import SemanticModal from "vue-ya-semantic-modal";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "WearDetails",
  components: {
    SemanticModal: SemanticModal(),
  },
  data() {
    return {
      showModal: false,
      serialNumber: "",
      quantityPerMachine: 0,
      companies: [],
      companyList: [],
      companyId: "",
      machines: [],
      machineId: "",
      assemblies: [],
      assemblyId: "",
      subAssemblies: [],
      subAssemblyId: "",
      part: "",
      parts: [],
      partId: "",
      pending: true,
      button: "",
      title: "",
    };
  },
  mounted() {
    this.getCompanies();

    if (this.$route.params.id === undefined) {
      $(".ui.dropdown .remove.icon").on("click", function(e) {
        $(this)
          .parent(".dropdown")
          .dropdown("clear");
        e.stopPropagation();
      });
      this.button = "Add";
      this.title = "Add";
    } else {
      this.wearDetails();
      this.button = "Save";
      this.title = "Edit";
    }
  },
  methods: {
    deleteModal() {
      this.showModal = !this.showModal;
    },
    onCompanyChange(event) {
      this.companyId = event.target.value;
      this.machines = [];
      this.machineId = "";
      this.assemblies = [];
      this.assemblyId = "";
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.parts = [];
      this.partId = "";
      this.getMachineSelectedItems();
    },
    onMachineChange(event) {
      this.machineId = event.target.value;
      this.assemblies = [];
      this.assemblyId = "";
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.parts = [];
      this.partId = "";
      this.getAssemblyList();
    },
    onAssemblyChange(event) {
      this.assemblyId = event.target.value;
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.parts = [];
      this.partId = "";
      this.getSubAssemblySelectedItems();
    },
    onSubAssemblyChange(event) {
      this.subAssemblyId = event.target.value;
      this.getPartsSelectedItems();
    },
    onPartsChange(event) {
      this.partId = event.target.value;
    },
    getMachineSelectedItems() {
      $("#MachineSelect").dropdown("destroy");
      let _this = this;
      apiService
        .getMachinesByCompany({
          id: _this.companyId,
        })
        .then((data) => {
          this.machines = data;
        })
        .then(() => {
          $("#MachineSelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
        })
        .then(() => {
          if (_this.assemblyId) {
            _this.getAssemblyList();
          }
        });
    },
    getAssemblyList() {
      $("#AssemblySelect").dropdown("destroy");
      apiService
        .getSelectItemsByCompanyMachine({
          id: this.machineId,
          showAll: true,
        })
        .then((data) => {
          this.assemblies = data;
        })
        .then(() => {
          $("#AssemblySelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
        })
        .then(() => {
          this.getSubAssemblySelectedItems();
        });
    },
    getSubAssemblySelectedItems() {
      if (this.assemblyId) {
        $("#SubAssemblySelect").dropdown("destroy");
        apiService
          .getSubAssemblyList({
            id: this.assemblyId,
          })
          .then((data) => {
            this.subAssemblies = data;
          })
          .then(() => {
            $("#SubAssemblySelect").dropdown("clear");
          })
          .then(() => {
            this.getPartsSelectedItems();
          });
      }
    },
    async getPartsSelectedItems() {
      if (this.subAssemblyId) {
        $("#PartIdSelect").dropdown("destroy");
        const data = await apiService.getSelectItemsByAssembly({
          id: this.subAssemblyId,
        });
        this.parts = data;
        $("#PartIdSelect").dropdown("clear");
      }
    },
    wearDetails() {
      apiService
        .getWearDetails({
          id: this.$route.params.id,
        })
        .then((request) => {
          this.wearSuccessful(request);
        })
        .catch((err) => this.wearFailed(err));
    },
    wearSuccessful(request) {
      this.serialNumber = request.serialNumber;
      this.quantityPerMachine = request.quantityPerMachine;
      this.machineId = request.machineId;
      this.assemblyId = request.assemblyId;
      this.subAssemblyId = request.subAssemblyId;
      this.partId = request.partId;
      this.companyId = request.companyId;
      this.pending = request.active;
    },
    wearFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    wearUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createWear({
            QuantityPerMachine: this.quantityPerMachine,
            MachineId: this.machineId,
            AssemblyId: this.subAssemblyId,
            PartId: this.partId,
            Active: this.pending,
            CompanyId: this.companyId,
          })
          .then((request) => {
            this.wearSuccessful(request);
            this.$router.push("/admin/wear");
          })
          .catch((err) => this.wearFailed(err));
      } else {
        apiService
          .updateWear({
            id: this.$route.params.id,
            QuantityPerMachine: this.quantityPerMachine,
            MachineId: this.machineId,
            AssemblyId: this.subAssemblyId,
            PartId: this.partId,
            Active: this.pending,
            CompanyId: this.companyId,
          })
          .then((request) => {
            this.wearSuccessful(request);
            this.$router.push("/admin/wear");
          })
          .catch((err) => this.wearFailed(err));
      }
    },
    wearDelete() {
      apiService
        .deleteWear({
          id: this.$route.params.id,
        })
        .then((request) => {
          this.wearSuccessful(request);
          this.$router.push("/admin/wear");
        })
        .catch((err) => this.wearFailed(err));
    },
    getCompanies() {
      $("#companiesSelect").dropdown("destroy");
      let _this = this;
      apiService
        .getCompaniesList()
        .then((data) => {
          this.companyList = data;
        })
        .then(() => {
          $("#companiesSelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
        })
        .then(() => {
          if (_this.machineId) {
            _this.getMachineSelectedItems();
          }
        });
    },
  },
};
</script>
